<template>
  <div class="school content">
     <div class="head">
        高考资讯
     </div>

     <div class="yuanxiaoku-sch-list-page" style="padding-bottom: 30px;">
        <div class="yuanxiaoku-sch-list-pages">
           <div style="width: 100%;display: flex;align-items: center;justify-content: center;padding-top: 10px;padding-bottom: 10px;">
             <el-input size="medium" placeholder="请输入文章名称" @keyup.enter.native="search()" style="width: 300px;" v-model="form.title"></el-input>
             <el-button type="success" style="margin-left: 10px;" size="medium" @click="search">搜索</el-button>
           </div>

        </div>
     </div>
     <div class="list">
       <el-empty description="暂无数据" v-if="list.length==0"></el-empty>
       <div class="lists" v-if="list.length>0" v-loading="loading">
           <div class="zixun01s" :style="{height:!item.imgurl?'40px':''
              }" @click="router(item)" v-for="(item,i) in list" :key="i">
              <div class="ban" v-if="item.imgurl">
                 <img :src="item.imgurl" alt="" v-if="item.imgurl">
                 <img src="@/assets/gkjypng.png" v-else alt="">
              </div>
              <div class="neirong" :style="{
                width:!item.imgurl?'100%':'',height:!item.imgurl?'90px':''
              }">
                 <div class="title" style="padding-top: 10px;">{{item.title}}</div>
            <!--     <div class="con">
                  {{item.infotion}}
                 </div> -->
                 <div class="time" v-if="item.time">{{timereturn(item.time)}}</div>
              </div>
           </div>
       </div>
     </div>
     <div style="width: 100%;display: flex;align-items: center;justify-content: center;padding-bottom: 30px;">
            <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="form.page"
                  :page-sizes="[100]"
                  :page-size="form.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
          </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
 import { InfoMation_index } from "@/api/gw/zonghe"
  export default {
    computed:{
      ...mapGetters(['isLogin',"userinfo"]),
    },
    data(){
      return{
         form:{
           page:1,
           limit:100,
           title:"",
           status:1
         },
         total:0,
         list:[],
      }
    },
    mounted(){
      this.getList();
    },
    methods:{
      timereturn(dateTime){
      	// 使用split方法以空格为分隔符分割字符串，得到一个数组
      	  // 数组的第一个元素是日期部分，第二个元素是时间部分
      	  const parts = dateTime.split(' ');
      	  // 使用join方法将分割后的数组重新组合成字符串，但只包含日期部分
      	  return parts[0];
      },
      //文章详情
      router(item){
        const routerUrl = this.$router.resolve({
              path:"/wenDetail?n=" + item.infomation_id
            })
            window.open(routerUrl.href,"_blank")
      },
      //搜索
      search(){
        this.form.page = 1
        this.getList();
      },
      //院校列表
      getList(){
        this.loading = true
        InfoMation_index(this.form).then(res=>{
          this.loading = false
          this.total = res.data.total
          this.list = res.data.data
        }).finally(()=>{
          this.loading = false
        })
      },
     handleSizeChange(val) {
       console.log(`每页 ${val} 条`);
       this.form.limit = val
       this.getList()
     },
     handleCurrentChange(val) {
       console.log(`当前页: ${val}`);
       this.form.page = val
       this.getList()
     },
    },
  }
</script>

<style lang="scss" scoped>
  .neirong{
    width: calc(100% - 184px);
    height: 114px;
    margin-left: auto;
    position: relative;
    cursor: pointer;
    .time{
      position: absolute;
      bottom: 0px;
      color: #687382;
      font-size: 16px;
      bottom: 10px;
    }
    .con{
      font-size: 18px;
      color: #687382;
      margin-top: 18px;
      line-height: 36px;
      overflow:hidden;

  text-overflow:ellipsis;

  display:-webkit-box;

  -webkit-box-orient:vertical;

  -webkit-line-clamp:2;
    }
    .title{
      font-size: 24px;
      font-weight: 400;
      white-space: nowrap; /* 防止换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 添加省略号 */
    }
    .title:hover,.con:hover,.time:hover{
      color: #058551;
    }
  }
  .zixun01s{
    height: 75px;
    display: flex;
    width: 100%;
    margin-bottom: 60px;
    .ban{
      width: 154px;
      height: 114px;
      border-radius: 10px;
      background: #ececec;
      cursor: pointer;
      img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }
  }
.bottom{
  width: 100%;
  height: 60px;
  background: #fff;
    box-shadow: 0 0 8px #ddd;
  position: fixed;
  left: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
  .sch-level{
    margin-top: 10px;
    color: #666666;
        height: 22px;
        display: flex;
        align-items: center;
        width: fit-content;
  }
  .sch-levels{
    margin-top: 10px;
    color: #666666;
    width: 100%;
  }
  .lists{
    width:92%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    .item-depart-title{
      color: #999999;
    }
    .col-line{
          color: #E7E7E7;
              padding: 0 10px;
    }
    .address{
      margin-top: 7px;
      color: #666666;
          height: 22px;
          display: flex;
          align-items: center;
          width: fit-content;
          .dingwei{
            width: 20px;
            height: 20px;
            margin-right:5px;
          }
    }
    .listcon{
      .info-box{
        flex: 1;
        font-size: 14px;
        .sch-title{
              display: flex;
              align-items: center;
              justify-content: space-between;
                  font-size: 16px;
                  line-height: 26px;
                  height: 26px;
        }
      }
      .logo{
            display: block;
            width: 68px;
            height: 68px;
            margin-right: 16px;
            img{
              width:100%;
              height: 100%;
              border-radius: 50%;
            }
      }
          box-sizing: border-box;
          padding: 20px 29px 22px;
          display: flex;
          align-items: center;
          width: calc(50% - 10px);
          background: #FFFFFF;
          margin-top: 20px;
          position: relative;
          margin-bottom: 20px;
    }
  }
  .list{
    width:1250px;
    margin:0 auto;
    min-height: 300px;
    background: #fff;
  }
  .item-options{
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        color: #333333;
  }
  .span{
    margin-right: 20px;margin-bottom: 10px;cursor: pointer;
  }
  .spanselect{
    color: #1CB278!important;
    font-weight: bold;
  }
  .span:hover{
    color: #1CB278!important;
  }
  .pri01{
    width: 84px;

    margin-right: 22px;
    color: #7B7B7B;
  }
  .pro{
    display: flex;
    flex-wrap: wrap;
  }
  .yuanxiaoku-sch-list-page{
    .yuanxiaoku-sch-list-pages{
      width: 1180px;
      margin: 0 auto;
    }
      width:1250px;
      margin: 0 auto;
      padding-top: 20px;
      padding-bottom: 20px;
      background: #FFFFFF;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
  }
.school{
  width: 100%;
  .head{
    width: 100%;
    height: 190px;
    background: linear-gradient(180deg,#49c48d,#1cb278);
    background: url(../../assets/yuanxiaoku.jpg) no-repeat;
    background-size: 100%;
    line-height: 190px;
    text-align: center;
    font-size: 38px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/zixun/index.vue